import { render, staticRenderFns } from "./MemberFlagForm.vue?vue&type=template&id=0ce2f3fd&"
import script from "./MemberFlagForm.vue?vue&type=script&lang=ts&"
export * from "./MemberFlagForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports